<template>
	<section class="post-header-vue">
		<div class="post-header-vue__breadcrumbs">
			<div class="container">
				<slot name="breadcrumbs"> </slot>
			</div>
		</div>
		<div class="post-header-vue__content">
			<div class="container">
				<div class="post-header-vue__content-inner">
					<div
						v-if="category"
						class="post-header-vue__category"
						v-html="category"
					></div>
					<h1 class="post-header-vue__title" v-html="title"></h1>
					<div v-if="image" class="post-header-vue__image">
						<img :src="image" :alt="title" />
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'PostHeader',
	props: {
		title: { type: String, required: true },
		category: { type: String, default: '' },
		image: { type: String, default: '' },
		breadcrumbs: { type: String, default: '' },
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.post-header-vue {
	background: var(--fpe-light-blue);
	padding: 0 0 0 0;
	text-align: center;

	&__breadcrumbs {
		background: var(--fpe-light-grey);
		padding: 60px 0 0 0;

		@media (max-width: $tablet) {
			padding: 0;
			display: none;
		}

		.container {
			#breadcrumbs {
				position: relative;
				grid-column: 1 / span 12;
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
				padding: 24px 0;

				@media (max-width: $tablet) {
					grid-column: 1 / span 4;
					padding: 0;
				}

				> span {
					display: flex;
					align-items: center;
					flex-wrap: wrap;

					@media only screen and (max-width: 768px) {
						&:first-child a {
							text-indent: -9999px;
							color: var(--fpe-blue);

							&.post {
								color: var(fpe-blue);
							}

							&::before {
								content: '…';
								text-indent: 0;
							}
						}
					}

					span {
						color: var(--fpe-blue);
						font: normal normal 300 14px/20px var(--primary-font-family);

						&.breadcrumb_last {
							color: var(--fpe-blue);
							font: normal normal 300 14px/20px var(--primary-font-family);
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							display: inline-block;

							@media (max-width: $tablet) {
								width: unset;
							}

							*,
							>>> {
								color: var(--fpe-blue);
							}
						}

						a {
							font: normal normal 300 14px/20px var(--primary-font-family);
							color: var(--fpe-blue);
							text-decoration: none;

							&:hover {
								text-decoration: underline;
							}

							&.post {
								color: var(fpe-blue);
							}
						}

						strong {
							font: normal normal 300 14px/20px var(--primary-font-family);
							color: var(--fpe-blue);

							&.post {
								color: var(fpe-blue);
							}
						}

						&.divider {
							&::before {
								margin: 0 16px 0;
								font: normal normal 300 11px/20px var(--primary-font-family);
								content: '/';
								display: inline-block;
								color: var(--fpe-blue);
							}
						}

						&:last-child {
							a {
								font: normal normal 300 14px/20px var(--primary-font-family);
							}
						}
					}
				}
			}
		}
	}

	&__content {
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 330px;

		@media (max-width: $tablet) {
			margin-bottom: 24px;
			grid-column: 1 / span 4;
		}

		.container {
			width: 100%;

			@media (max-width: $tablet) {
				width: unset;
			}
		}

		&-inner {
			padding: 64px 0 0 0;
			grid-column: 6 / span 6;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin-bottom: -330px;

			@media (max-width: $tablet) {
				margin-bottom: 0;
				grid-column: 1 / span 4;
				padding-top: 24px;
			}
		}
	}

	&__category {
		color: var(--fpe-blue);
		font-size: 20px;
		margin-bottom: 0;
		text-align: left;
		width: 100%;
		max-width: 100%;
	}

	&__title {
		color: var(--fpe-blue);
		margin-bottom: 64px;
		text-align: left;
		width: 100%;
		max-width: 600px;

		@media (max-width: $tablet) {
			grid-column: 1 / span 4;
			padding-top: 0;
			margin-bottom: 36px;
		}
	}

	&__image {
		margin: 0 auto;
		max-width: 100%;
		aspect-ratio: 16/9;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style> 


// WEBPACK FOOTER //
// resources/assets/scripts/vue/PostHeader.vue